import React, { Component } from 'react';

const TermsPageForm = () => {
    return ( <h1>Terms Page Form</h1> );
}
 
export default TermsPageForm;